import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var CloudDataTransferFilledSvg = function CloudDataTransferFilledSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#61676B",
    fillRule: "evenodd",
    d: "M12 1a7 7 0 0 0-6.39 4.138A7.002 7.002 0 0 0 5 18.71v-4.453L8.257 11H17.5v6H19v1.917a6.002 6.002 0 0 0-.06-11.844A7 7 0 0 0 12 1m1 22h1.914L17 20.914V19h-1.5v-6H13zm-4.5 0H11V13H9.086L7 15.086V17h1.5z",
    clipRule: "evenodd"
  }));
};
export var CloudDataTransferFilled = function CloudDataTransferFilled(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: CloudDataTransferFilledSvg
  }));
};